export default "__VITE_ASSET__93K3grwS__"